<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
                Nuevo Registro
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Medio</th>
          <th scope="col">Descripción</th>
          <th scope="col">Fecha de registro</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="mediopers in datosPaginados" :key="mediopers.idMedioPers">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(mediopers.idMedioPers)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ mediopers.medioComNombre }}</td>
          <td>{{ mediopers.descripcion }}</td>
          <td>{{ getFormattedDate(mediopers.fechaReg, "DD/MM/YYYY") }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteMedioPers(mediopers.idMedioPers)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioPers" class="form-label"
                      >IdMedioPers</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idMedioPers"
                      name="idMedioPers"
                      v-model="datoMedioPers.idMedioPers"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Medio Com -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioCom" class="form-label">
                      Medio Com</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idMedioCom"
                      name="idMedioCom"
                      v-model="datoMedioPers.idMedioCom"
                    >
                      <option
                        v-for="medioCom in medioComs"
                        :value="medioCom.idMedioCom"
                        :key="medioCom.idMedioCom"
                      >
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Medio Com -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label"
                      >Descripción</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoMedioPers.descripcion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      :value="getFormattedDate(datoMedioPers.fechaReg)"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarMedioPers"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarMedioPers"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import api from "@/services/api";	
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idPersona: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      medioperss: [],
      datoMedioPers: {},
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      medioComs: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  watch: {
    p_idPersona(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDataPaginaTodos(this.paginaActual);
      }
    },
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchMedioComs();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.medioperss.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwmedioperss/idpersona/" +
            this.p_idPersona
        )
        .then((response) => {
          this.medioperss = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.medioperss.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idMedioCom", "descripcion"];
      const requiredFieldsText = ["idMedioCom", "descripcion"];
      return validarForm(
        this.datoMedioPers,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarMedioPers() {
      if (this.validarForm() === 1) {
        try {
          this.datoMedioPers.idPersona = this.p_idPersona;
          await api.post("/medioperss",
            this.datoMedioPers
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "MedioPers creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarMedioPers() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/medioperss",
            this.datoMedioPers
          );
          $("#ventanaModal").modal("hide");
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "MedioPers creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoMedioPers = {};
      this.titulo = "Crear Persona: Medios de Comunicación";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idMedioPers) {
      this.modalWindow = true;
      if (idMedioPers != null) {
        api.get("/vwmedioperss/" + idMedioPers)
          .then((resp) => {
            this.datoMedioPers = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Persona: Medios de Comunicación";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    async deleteMedioPers(idMedioPers) {
      try {
        await api.delete("/medioperss/" + idMedioPers
        );
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchMedioComs() {
      fetch(config.apiBaseUrl + "/vwmediocoms")
        .then((response) => response.json())
        .then((data) => {
          this.medioComs = data;
        })
        .catch((error) => {
          console.error("Error fetching medioComs:", error);
        });
    },
  },
};
</script>
